import React from "react";

// Style \\
import "../../assets/styles/sections/aboutHero.scss";

const AboutHero = () => {
  return (
    <section className="heroAbout">
      <div className="heroAbout_bg">
        <div className="containers">
          <div className="hero_items">
            <div className="hero_items_title">
              <p>Home / About</p>
              <h2>About us</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
